import React from 'react';

const LogoutConfirmModal = ({ isOpen, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-[#14243c] rounded-lg p-6 max-w-md w-full mx-4 shadow-xl border border-gray-700">
        <h2 className="text-xl font-bold mb-4 text-white">Confirm Navigation</h2>
        
        <p className="mb-6 text-gray-300">
          Going back will log you out of your current session. Are you sure you want to continue?
        </p>
        
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-600 hover:bg-gray-700 rounded-md text-white transition-colors"
          >
            Stay Here
          </button>
          
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-green-600 hover:bg-green-700 rounded-md text-white transition-colors"
          >
            Logout and Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmModal;
/*******og-Code****************************************************************************************************************************************************************************************************************************************************************************************************************************************** */
//// import React from 'react';

// const LogoutConfirmModal = ({ isOpen, onConfirm, onCancel }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//       <div className="bg-[#14243c] rounded-lg p-6 max-w-md w-full mx-4 shadow-xl border border-gray-700">
//         <h2 className="text-xl font-bold mb-4 text-white">Logout Confirmation</h2>
        
//         <p className="mb-6 text-gray-300">
//           Are you sure you want to go back? This will log you out of your account.
//         </p>
        
//         <div className="flex justify-end gap-3">
//           <button
//             onClick={onCancel}
//             className="px-4 py-2 bg-gray-600 hover:bg-gray-700 rounded text-white transition-colors"
//           >
//             Cancel
//           </button>
          
//           <button
//             onClick={onConfirm}
//             className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded text-white transition-colors"
//           >
//             Logout and Go Back
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LogoutConfirmModal;